import { createContext, useContext } from 'react';
import { useTranslation } from 'react-i18next';

import Notice from './Notice.tsx';

// Shown beside an unexpected error (the generic message), e.g. a button to report it (plan task 98). Filled where the
// app knows who's signed in, so the core component doesn't depend on the API; nothing without it.
export const UnexpectedErrorActionContext = createContext<React.ReactNode>(null);

interface ErrorMessageProps {
    // A translation key or plain text; nothing is rendered without one.
    message: string | null | undefined;
    className?: string;
}

// Why an action failed, e.g. a save the server rejected.
const ErrorMessage = ({ message, className }: ErrorMessageProps) => {
    const { t, i18n } = useTranslation();
    const unexpectedErrorAction = useContext(UnexpectedErrorActionContext);
    if (!message) return null;

    return (
        <Notice
            tone="negative"
            role="alert"
            className={className}
            title={i18n.exists(message) ? t(message as 'errors.failed') : message}
            action={message === 'errors.failed' ? unexpectedErrorAction : undefined}
        />
    );
};

export default ErrorMessage;
